<template>
  <div class="bg-red-500">
    <h1>Ik ben Henk, het testcomponent.</h1>
  </div>
</template>
